/*
 *  This code was originally in bm-experimental. It is intentionally written in JavaScript,
 *  as it was originally intended to be common code which could be shared with the Front End Framework.
 */
(function (window, angular) {
    'use strict';
    var RxSignal = (function() {
        function RxSignalImpl(observable, initialValue) {
            if(!(this instanceof RxSignalImpl)) {
                throw new Error('Constructor called as a function');
            }

            if(typeof observable === 'undefined' || observable === null) {
                throw new Error('RxSignalImpl: observable is undefined.');
            }

            if(typeof observable.subscribe === 'undefined' || observable.subscribe === null) {
                throw new Error('RxSignalImpl: expecting observable to have subscribe function.');
            }
            var self = this;
            this.value = initialValue;
            observable.subscribe(function(value) {
                self.value = value;
            });
        }

        return RxSignalImpl;
    }());

    var RxUtils = (function() {

        var _$inject = ['fef.SanityChecks', '$q'];
        function RxUtilsImpl(sanityChecks, $q) {

            sanityChecks.checkConstructorUsage(this, RxUtilsImpl);

            this.types = {
                RxSignal: RxSignal
            };

            /**
             * Creates a promise out of an observable by resolving with the first value observed.
             * @param {Rx.Observable} observable
             * @returns {Promise}
             */
            this.createOnNextPromise = function(observable) {
                var deferred = $q.defer();
                var subscription = observable.subscribe(function(value) {
                    deferred.resolve(value);
                }, function(error) {
                    deferred.reject(error);
                }, function() {
                    // 'completion without error or value' is not directly translateable to promises,
                    // which either resolve with a value or reject with an error. My best guess is to just
                    // resolve with undefined.
                    deferred.resolve(undefined);
                });

                // we don't need this subscription anymore, so we can unsubscribe early.
                deferred.promise.catch(function () {
                    angular.noop();
                })['finally'](function() {
                    subscription.dispose();
                });

                return deferred.promise;
            };
        }
        RxUtilsImpl.$inject = _$inject;

        return RxUtilsImpl;
    }());

    angular.module('bmpRxUtils', ['fef']).service('bmpRxUtils', RxUtils);

}(window, window.angular));
